<template>
<div class="message">
	<div class="van-nav-bar van-hairline--bottom custom-nav-bar">
		<div class="van-nav-bar__content">
			<div class="van-nav-bar__left van-haptics-feedback" @click="back()">
				<i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
			</div>
			<div class="van-nav-bar__title van-ellipsis">
				{{$t('systemNotice')}}
			</div>
		</div>
	</div>
	<div class="content-wrapper">
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
			<div class="notice-container">
				<div class="notice-card">
					<div class="notice-header">
						<h3 class="notice-title">{{notice.name}}</h3>
					</div>
					<div class="notice-content">
						<div style="white-space: pre-wrap;" v-html="notice.text"></div>
					</div>
					<div class="notice-time" v-if="notice.create_time">
						{{notice.create_time}}
					</div>
				</div>
			</div>
			<van-empty :description="$t('common.nodata')" v-if="!notice.name" class="custom-empty" />
		</van-pull-refresh>
	</div>
	<van-dialog v-model="show24" :title="dtitle" class="custom-dialog">
		{{dcontent}}	  
	</van-dialog>
</div>
</template>

<script>

export default {
  data() {
    return {
      isLoading: false,
      notice:{},
	  show24:false,
	  dtitle:'',
	  dcontent:'',
      loading: false,
      finished: false,
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getNoticeList(){
      this.$http({
        method: 'get',
        url: 'sys_get_notice_list'
      }).then(res=>{
        console.log(res);
        this.notice = res.data[0]
      })
    },
	showD(title,content){
		this.dtitle = title;
		this.dcontent = content;
		this.show24 = true;
	},
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('common.refresh'));
        this.isLoading = false;
        this.getNoticeList();
      }, 500);
    },
  },
  created() {
    this.getNoticeList();
  }
};
</script>

<style lang='less' scoped>
:export {
    gbcolor: linear-gradient(135deg, #3498db, #8e44ad)
}

.message {
    width: 100%;
    min-height: 100vh;
    background: white;
}

/* 顶部导航栏样式 - 填充渐变色 */
.custom-nav-bar {
    height: 3.5rem;
    line-height: 3.5rem;
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    position: relative;
    z-index: 10;
}

.custom-nav-bar::after {
    display: none;
}

.van-nav-bar__title {
    max-width: 60%;
    margin: 0 auto;
    color: white !important;
    font-weight: 600;
    font-size: 1.1rem;
}

.van-nav-bar__left {
    padding: 0 15px;
}

.van-nav-bar__arrow {
    color: white !important;
    font-size: 1.2rem;
    font-weight: bold;
}

/* 内容区域 */
.content-wrapper {
    padding: 1rem;
    background: white;
}

.notice-container {
    max-width: 100%;
}

/* 通知卡片带边框 */
.notice-card {
    border: 1.5px solid #e8e8e8;
    border-radius: 12px;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    overflow: hidden;
    transition: all 0.3s ease;
}

.notice-card:active {
    border-color: #6d65c6;
    transform: translateY(1px);
}

.notice-header {
    padding: 1rem 1.2rem 0.5rem;
    border-bottom: 1px solid #f0f0f0;
    background: linear-gradient(135deg, #f8f9ff, #f0f2ff);
}

.notice-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.notice-content {
    padding: 1.2rem;
    color: #555;
    font-size: 0.95rem;
    line-height: 1.6;
    background: white;
}

.notice-content div {
    word-wrap: break-word;
}

.notice-time {
    padding: 0.8rem 1.2rem;
    background: #f8f9fa;
    border-top: 1px solid #f0f0f0;
    color: #969799;
    font-size: 0.8rem;
    text-align: right;
}

/* 空状态样式 */
.custom-empty {
    padding: 3rem 1rem;
}

::v-deep .van-empty__description {
    color: #969799;
    font-size: 0.9rem;
}

/* 自定义对话框样式 */
::v-deep .custom-dialog .van-dialog__header {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    padding: 1rem 1.5rem 0.5rem;
}

::v-deep .custom-dialog .van-dialog__content {
    padding: 1rem 1.5rem;
    color: #555;
    font-size: 0.95rem;
    line-height: 1.6;
}

::v-deep .custom-dialog .van-dialog__confirm {
    color: #6d65c6;
}

/* 下拉刷新样式 */
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
    color: #667eea;
    font-size: 0.9rem;
}

::v-deep .van-loading__text {
    color: #969799;
    font-size: 0.9rem;
}

/* 动画效果 */
@keyframes fadeIn {
    from { 
        opacity: 0; 
        transform: translateY(20px); 
    }
    to { 
        opacity: 1; 
        transform: translateY(0); 
    }
}

.notice-card {
    animation: fadeIn 0.5s ease forwards;
}

/* 响应式调整 */
@media (max-width: 320px) {
    .content-wrapper {
        padding: 0.8rem;
    }
    
    .notice-header {
        padding: 0.8rem 1rem 0.4rem;
    }
    
    .notice-content {
        padding: 1rem;
        font-size: 0.9rem;
    }
    
    .notice-time {
        padding: 0.6rem 1rem;
    }
    
    .notice-title {
        font-size: 1rem;
    }
}

/* 移除旧样式 */
.van-cell-group {
    background: transparent;
    border: none;
}

.van-cell-group::after,
.van-cell-group::before {
    display: none;
}
</style>
